import { RadioButton } from "./Radio"

export const RadioInput = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldTouched, handleChange }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  options,
  ...props
}) => (
  <RadioButton
    label={props.label}
    onChange={handleChange(field.name)}
    value={field.value}
    checked={field.value?.toString() === props.value?.toString()}
    errors={
      !!touched[field.name] && !!errors[field.name]
        ? [errors[field.name]]
        : undefined
    }
    disabled={props.disabled}
    sx={props.sx}
    {...props}
  />
)
